import { BaseIcon, BaseIconProps } from "./baseIcon";

export const EarnInactiveIcon = (props: BaseIconProps) => {
  return (
    <BaseIcon {...props}>
      <g id="Earn">
        <path
          d="M10.7999 2C15.2182 2 18.7999 5.58172 18.7999 10C18.7999 14.4183 15.2182 18 10.7999 18C6.38165 18 2.79993 14.4183 2.79993 10C2.79993 5.58172 6.38165 2 10.7999 2ZM9.79993 7C8.69536 7 7.79993 7.89543 7.79993 9V11C7.79993 12.1046 8.69536 13 9.79993 13H11.7999C12.9045 13 13.7999 12.1046 13.7999 11V9C13.7999 7.89543 12.9045 7 11.7999 7H9.79993Z"
          className="oui-fill-base-contrast-36"
        />
        <path
          d="M19.6034 8.12792C19.5435 7.84606 19.8606 7.62751 20.0758 7.81905C21.7464 9.30546 22.7998 11.4698 22.7998 13.8818C22.7998 18.3653 19.1651 22 14.6816 22C12.2696 21.9999 10.1053 20.9466 8.61887 19.276C8.42732 19.0607 8.64587 18.7437 8.92773 18.8036C9.53159 18.9319 10.1577 19 10.7998 19C10.9363 19 11.0722 18.9959 11.2072 18.9895C11.2718 18.9864 11.3356 19.0039 11.3901 19.0387C12.3405 19.6468 13.4696 20 14.6816 20C17.955 20 20.6283 17.429 20.792 14.1963L20.7998 13.8818C20.7998 12.6698 20.4466 11.5407 19.8385 10.5903C19.8037 10.5358 19.7862 10.472 19.7893 10.4074C19.7957 10.2724 19.7998 10.1366 19.7998 10C19.7998 9.3579 19.7318 8.73178 19.6034 8.12792Z"
          className="oui-fill-base-contrast-12"
        />
      </g>
    </BaseIcon>
  );
};
